export default __webpack_public_path__ + "static/agent4-5732eae6eb351d914c24e48ef0d08e53.png";